import { contact } from '@round/api';

export const notificationTypeLabels: Record<contact.NotificationType, string> = {
    SONG_PROMO_CHASE: 'Song Promo Chase',
    SONG_PROMO_INITIAL_REGISTERED: 'Song Promo Initial Registered',
    SONG_PROMO_INITIAL_UNREGISTERED: 'Song Promo Initial Unregistered',
    WAVE_INVITE: 'Wave Invite',
    WAVE_INVITE_CHASE: 'Wave Invite Chase',
};

export const MICROWAVE_APP_DOMAIN = 'https://app.micro-wav.com';
